import DobSearch from './DobSearch';
import HOInternal from './HOInternal';
import React from 'react';
import ReportData from './ReportData';
import ReportSearch from './ReportSearch';
import { connect } from 'react-redux';
import { toUpper } from 'lodash';

export const Report = ({ isDob = false, username, isHO = false, isBankStaff = false, isBO = false, isTO = false, isFSC = false  }) => {
  const renderDob = () => {
    return (
      <>
        <DobSearch />
      </>
    );
  };

  const renderDefault = () => {
    return (
      <>
        <ReportSearch />
        <ReportData />
      </>
    );
  };

  const renderEmpty = () => {
    return (
        <>
        </>
    );
  };

  const isInternalHO = () => {
    return isDob && toUpper(username).includes('VNM'); // TODO bad bad bad
  };

  const renderInternalHO = () => {
    return <HOInternal />;
  };

  const render = () => {
    if (isInternalHO()) return renderInternalHO();
    if (isDob) return renderDob();
    if(isBankStaff || isBO || isTO || isFSC) return renderDefault();
    return renderEmpty();
  };

  return (
    <div className='report mx-5'>
      <div className='mt-5'>
        <h3 className='text-primary'>BÁO CÁO GIỚI THIỆU KHÁCH HÀNG</h3>
      </div>
      <div>{render()}</div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const isDob = state?.auth?.authorities?.map((e) => e.authority)?.includes('ROLE_DOB');
  const isHO = state?.auth?.authorities?.map((e) => e.authority)?.includes('ROLE_HO');
  const isBO = state?.auth?.authorities?.map((e) => e.authority)?.includes('ROLE_BO');
  const isTO = state?.auth?.authorities?.map((e) => e.authority)?.includes('ROLE_TO');
  const isFSC = state?.auth?.authorities?.map((e) => e.authority)?.includes('ROLE_FSC');
  const isBankStaff = state?.auth?.authorities?.map((e) => e.authority)?.includes('ROLE_BANKSTAFF');
  const username = state?.auth?.name;
  return { isDob, username, isHO,isBO, isTO, isBankStaff, isFSC };
};

export default connect(mapStateToProps)(Report);
